export default function useDynamicCharacterCounter(width, height) {
  const H5_FONT_SIZE = 18
  const SM_FONT_SIZE = 14
  const SM_LINE_HEIGHT = 1.5
  const AVG_CHAR_WIDTH_RATIO = 0.55

  const PADDING = 2 * 2
  const GAP = 12
  const TITLE_HEIGHT_EM = 2.8

  // Calculate actual heights
  const titleHeight = TITLE_HEIGHT_EM * H5_FONT_SIZE
  const availableTextHeight = height - PADDING - titleHeight - GAP

  // Calculate line capacity for text area
  const lineHeight = SM_FONT_SIZE * SM_LINE_HEIGHT
  const lineCap = Math.floor(availableTextHeight / lineHeight)

  // Calculate character capacity per line (for both title and text)
  const availableWidth = width - PADDING
  const titleCharsPerLine = Math.floor(availableWidth / (H5_FONT_SIZE * AVG_CHAR_WIDTH_RATIO))
  const textCharsPerLine = Math.floor(availableWidth / (SM_FONT_SIZE * AVG_CHAR_WIDTH_RATIO))

  // Title: always 2 lines clamp (per requirements)
  const maxTitleCount = titleCharsPerLine * 2

  // Text: calculated lines × chars per line
  const maxTextCount = textCharsPerLine * Math.max(1, lineCap)

  // Apply safety factor to prevent ellipsis from appearing prematurely
  // Reduce by 5% to account for font rendering variations and word wrapping
  // More conservative to prevent text overflow outside drag handles
  const SAFETY_FACTOR = 0.95
  const safeTitleCount = Math.floor(maxTitleCount * SAFETY_FACTOR)
  const safeTextCount = Math.floor(maxTextCount * SAFETY_FACTOR)

  return {
    maxTitleCount: Math.max(10, safeTitleCount),
    maxTextCount: Math.max(50, safeTextCount),
    lineCap: Math.max(1, lineCap),
  }
}
